import React from 'react';
import Sidebar from '../components/sidebar';
import { Card, Row, Col, Button, Typography, Divider } from 'antd';
import { CrownOutlined, StarOutlined, RocketOutlined, TrophyOutlined } from '@ant-design/icons';
import './Membresias.css';

const { Title, Text } = Typography;

const Membresias = () => {
  const membresias = [
    {
      id: 'networker',
      nombre: 'NETWORKER',
      icono: <StarOutlined />,
      precioSinIva: 194,
      precioConIva: 220,
      color: '#52c41a',
      caracteristicas: [
        'Acceso básico a la plataforma',
        'Herramientas de networking',
        'Soporte técnico básico',
        'Comunidad de usuarios',
        '📊 Hasta 2 campañas en simultáneo',
        '🔐 Generador de contraseñas: No incluye'
      ]
    },
    {
      id: 'business',
      nombre: 'BUSINESS',
      icono: <CrownOutlined />,
      precioSinIva: 395,
      precioConIva: 449,
      color: '#1890ff',
      caracteristicas: [
        'Todo lo de Networker',
        'Herramientas avanzadas de negocio',
        'Soporte técnico prioritario',
        'Análisis de rendimiento',
        'Integración con APIs',
        '📊 Hasta 5 campañas en simultáneo',
        '🔐 Generador de contraseñas: No incluye'
      ]
    },
    {
      id: 'mentory',
      nombre: 'MENTORY',
      icono: <RocketOutlined />,
      precioSinIva: 1799,
      precioConIva: 2029,
      color: '#722ed1',
      caracteristicas: [
        'Todo lo de Business',
        'Mentoría personalizada',
        'Consultoría estratégica',
        'Acceso a expertos',
        'Sesiones 1 a 1',
        '📊 Hasta 10 campañas en simultáneo',
        '🔐 Generador de contraseñas: Incluido'
      ]
    },
    {
      id: 'certification',
      nombre: 'CERTIFICATION',
      icono: <TrophyOutlined />,
      precioSinIva: 3395,
      precioConIva: 3836,
      color: '#fa8c16',
      caracteristicas: [
        'Todo lo de Mentory',
        'Certificación oficial CIRP',
        'Programa de entrenamiento completo',
        'Acceso a contenido exclusivo',
        'Soporte 24/7',
        '📊 Campañas ilimitadas',
        '🔐 Generador de contraseñas: Incluido'
      ]
    }
  ];

  const handleUpgrade = (membresia) => {
    console.log(`Upgrade a ${membresia.nombre}`);
    // Aquí puedes agregar la lógica para procesar el upgrade
    alert(`Procesando upgrade a ${membresia.nombre} - $${membresia.precioConIva} USD`);
  };

  return (
    <div>
      <Sidebar>
        <div className="membresias-container">
          <div className="text-center mb-4">
            <Title level={3} className="membresias-title">
              🚀 UPGRADE DE MEMBRESÍA
            </Title>
            <Text className="membresias-subtitle">
              Elige el plan que mejor se adapte a tus necesidades
            </Text>
          </div>

          <Row gutter={[24, 24]} justify="center">
            {membresias.map((membresia) => (
              <Col xs={24} sm={12} lg={6} key={membresia.id}>
                <Card
                  className={`membresia-card ${membresia.id}`}
                  hoverable
                  style={{ 
                    border: `2px solid ${membresia.color}`,
                    borderRadius: '16px',
                    height: '100%'
                  }}
                >
                  <div className="text-center mb-3">
                    <div 
                      className="membresia-icon"
                      style={{ color: membresia.color }}
                    >
                      {membresia.icono}
                    </div>
                    <Title level={5} style={{ color: membresia.color, margin: '12px 0 4px 0' }}>
                      CIRP MEMBRESÍA
                    </Title>
                    <Title level={4} style={{ color: membresia.color, margin: '0 0 12px 0' }}>
                      {membresia.nombre}
                    </Title>
                  </div>

                  <div className="precios-container mb-3">
                    <div className="precio-item">
                      <Text strong>SIN I.V.A.</Text>
                      <Title level={4} style={{ margin: '2px 0', color: '#52c41a' }}>
                        USD {membresia.precioSinIva}
                      </Title>
                    </div>
                    <Divider />
                    <div className="precio-item">
                      <Text strong>CON I.V.A.</Text>
                      <Title level={4} style={{ margin: '2px 0', color: '#1890ff' }}>
                        USD {membresia.precioConIva}
                      </Title>
                    </div>
                  </div>

                  <div className="caracteristicas mb-3">
                    {membresia.caracteristicas.map((caracteristica, index) => (
                      <div key={index} className="caracteristica-item">
                        <Text>✓ {caracteristica}</Text>
                      </div>
                    ))}
                  </div>

                  <Button
                    type="primary"
                    size="middle"
                    block
                    style={{
                      backgroundColor: '#000000',
                      borderColor: '#000000',
                      borderRadius: '8px',
                      height: '40px',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                    onClick={() => handleUpgrade(membresia)}
                  >
                    UPGRADE AHORA
                  </Button>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-4">
            <Card className="info-card">
              <Title level={5}>💡 ¿Necesitas ayuda para elegir?</Title>
              <Text>
                Nuestro equipo de soporte está disponible para ayudarte.
              </Text>
            </Card>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default Membresias;
